export default __webpack_public_path__ + "static/media/22.1cb5f326.jpg";